/*--------------------------------------
 ANIMATIONS
 --------------------------------------*/
Animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { y: 30 },
                { y: 0, duration: 1, ease: "expo.out" },
                0
            );
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1.5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadeinquik]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: .5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

    }
};

/*--------------------------------------
                 HEADER
 --------------------------------------*/
mobileMenu = {
    init: function () {
        $(".btn-submenu-mobile").off("click.mobileMenu").on("click.mobileMenu", function (e) {
            e.preventDefault();
            $(this).closest(".header-mobile__nav--lists").toggleClass("open");
        });

        function setMenuState(isOpen) {
            $("body").toggleClass("open-menu-mobile", isOpen);
            $(".btn-menu-mobile").attr("aria-expanded", isOpen);
            $(".header-mobile-menu").attr("aria-hidden", !isOpen);
        }

        $(".btn-menu-mobile").off("click.mobileMenu").on("click.mobileMenu", function (e) {
            e.preventDefault();
            setMenuState(!$("body").hasClass("open-menu-mobile"));
        });

        $(".header-mobile-menu__close, .header-mobile-menu__link, .header-mobile-menu__layer")
            .off("click.mobileMenu")
            .on("click.mobileMenu", function () {
                setMenuState(false);
            });

        $(document).off("keydown.mobileMenu").on("keydown.mobileMenu", function (e) {
            if (e.key === "Escape") {
                setMenuState(false);
            }
        });
    }
};

pageHero = {
    init: function () {
        if ($(".page-hero").length > 0) {
            $("body").addClass("page-hero");
        }
    },
};

headerColor = {
    init: function () {
        $(".header-transparent").each(function (index) {
            var item = $(this);
            var key = $(this).data("key");
            var controller = new ScrollMagic.Controller();

            var scene = new ScrollMagic.Scene({
                triggerElement: ".header-trigger--" + key,
                duration: item.outerHeight(),
                triggerHook: "0",
            })
                .on("enter", function () {
                    $("body").addClass("header-transparent");
                })
                .on("leave", function () {
                    $("body").removeClass("header-transparent");
                })
                .addTo(controller);
        });
    },
};

homeHeaderColor = {
    init: function () {
        if (!$("body").hasClass("index")) {
            return;
        }

        var firstSection = $("#MainContent > .shopify-section").first();

        if (!firstSection.length) {
            firstSection = $(".slider").first();
        }

        if (!firstSection.length) {
            return;
        }

        function updateHeaderColor() {
            var sectionEnd = firstSection.offset().top + firstSection.outerHeight() - $(".section-header").outerHeight();
            $("body").toggleClass("home-header-hero", $(window).scrollTop() < sectionEnd);
        }

        updateHeaderColor();
        $(window).off("scroll.homeHeaderColor resize.homeHeaderColor").on("scroll.homeHeaderColor resize.homeHeaderColor", updateHeaderColor);
    },
};


/*--------------------------------------
                 FOOTER 
 --------------------------------------*/

footerScrollToNewsletter = {
    init: function () {
        $("a[href='#newsletter']").on("click", function (e) {
            e.preventDefault();

            var $newsletterSection = $(".section-newsletter");
            if ($newsletterSection.length > 0) {
                $('html, body').animate({
                    scrollTop: $newsletterSection.offset().top - $(".section-header").outerHeight()
                }, 800);
            }
        });
    },
};


/*--------------------------------------
                 OTHERS 
 --------------------------------------*/

dynamicViewHeight = {
    init: function () {
        // La gràcia d'aquest sistema és que ara si gires la pantalla del mòbil / tablet el vh s'adaptarà
        var orientation = window.orientation;

        updateViewHeight();

        $(window).on("resize", function () {
            if (window.orientation != orientation) {
                orientation = window.orientation;
                updateViewHeight();
            }
        });

        function updateViewHeight() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        }
    },
};

scrollToSSLL = {
    init: function () {
        /** Scroll to a part of the page by classname or by pixel number
        *  -  href="website.com/?scrollto=classname"   ==>  Loads new page and scroll to div with class 'classname'
        *  -  href="scrollto:classname"                ==>  Scrolls to div with class 'classname'
        *  -  href="scrollto:next"                     ==>  Scrolls to next section with class 'block'
        *  -  href="scrollto:0"                        ==>  Scrolls to pixel 0 (top of page)
        *
        * by Lluc  :)
        **/


        /*  --  CLICK LINK  --  */
        $('a[href^="scrollto:"]').on('click', function (e) {
            $("body").removeClass('menu--open');
            e.preventDefault();
            history.pushState(null, null, ' ');

            var btn = $(this);
            var target = $(this).attr('href').split(':')[1];

            scroll(btn, target)
        });


        /*  --  PAGE LOAD  --  */
        var params = getQueryStringParameters(window.location.href);
        if (params['scrollto']) {
            var target = params['scrollto'];
            scroll(null, target);
            removeQueryParam('scrollto', window.location.href);
        }


        /*  --  FUNCTIOMS  --  */

        function scroll(btn, target) {
            if (target == 'next') {

                var nextSection = btn.closest('.shopify-section').next('.shopify-section');
                if (nextSection.length) {
                    $('html, body').animate({
                        scrollTop: $(nextSection).offset().top
                    }, 800);
                }

            } else if ($('.' + target).length) {
                $('html, body').animate({
                    scrollTop: $('.' + target).offset().top
                }, 800);

            } else if (isNumber(target)) {
                $('html, body').animate({
                    scrollTop: target
                }, 800);
            }
        }

        function isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function getQueryStringParameters(url) {
            var params = {};
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        }

        function removeQueryParam(param, url) {
            var urlObj = new URL(url);
            urlObj.searchParams.delete(param);
            window.history.pushState({}, '', urlObj.href);
        }
    }
};

animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { y: 30 },
                { y: 0, duration: 1, ease: "expo.out" },
                0
            );
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1.5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadeinquik]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: .5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

    }
};

pngToSvg = {
    init: function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }
};

Search = {
    init: function () {

        //OPEN IN MENU
        $(".section-header .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header .search-input").addClass("open");
            $("body").removeClass("open-search-home");
            $("body").addClass("open-search");
            $(".section-header .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header .search-input input.input-search").on("input", function () {
            $(".section-header .search-input__content").addClass("start");
        });

        //OPEN IN MENU HOME
        $(".section-header-home .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header-home .search-input").addClass("open");
            $("body").removeClass("open-search");
            $("body").addClass("open-search-home");
            $(".section-header-home .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header-home .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header-home .search-input input.input-search").on("input", function () {
            $(".section-header-home .search-input__content").addClass("start");
        });


        //CLOSE
        $(".btn-close-search").on("click", function () {
            $(".search-input").removeClass("open");
            $(".search-input input.input-search").val("");
            $(".search-input__content").removeClass("start");
            $("body").removeClass("open-search");
            $("body").removeClass("open-search-home");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-search, .search-input').length) {
                $(".search-input").removeClass("open");
                $(".search-input input.input-search").val("");
                $(".search-input__content").removeClass("start");
                $("body").removeClass("open-search");
                $("body").removeClass("open-search-home");
            }
        })
    }
};

$(document).ready(function () {
    // HEADER
    mobileMenu.init();
    headerColor.init();
    homeHeaderColor.init();
    pageHero.init();

    // FOOTER
    footerScrollToNewsletter.init();

    // OTHERS
    scrollToSSLL.init();
    animations.init();
    pngToSvg.init();
    Search.init();
});

$(document).on('shopify:section:load', function (event) {
    animations.init();
});
